import React, { useState, useEffect } from "react";
import { Transition, Dialog } from "@headlessui/react";
import { Button } from "@mantine/core";
import { useTheme } from "../../../ThemeContext";
import ProjectName from "../../Dropdowns/ProjectNames";
import { addSafetyInspection, updateSafetyInspection } from "../../../api/api";
import { formatedDate } from "../../../api/services";

const SafetyAuditForm = ({ isOpen, onClose, edit, editData, handleUpdate }) => {
  const { theme } = useTheme();
  const isDark = theme === "dark";
  const [safetyId, setSafetyId] = useState('');
  const [pname, setPname] = useState('');
  const [siteEngineerName, setSiteEngineerName] = useState('');
  const [qualityInspectorName, setQualityInspectorName] = useState('');
  const [safetyIssues, setSafetyIssues] = useState('');
  const [safetyAudit, setSafetyAudit] = useState('');
  const [incidentType, setIncidentType] = useState('');
  const [comments, setComments] = useState('');
  const [automatedFollowUps, setAutomatedFollowUps] = useState(false);
  const [description, setDescription] = useState('');
  const [deadLine, setDeadLine] = useState('');
  const [result, setResult] = useState('');
  const [area,setArea]=useState('')

  // Pre-fill form if editing
  useEffect(() => {
    if (edit && editData) {
      setSafetyId(editData._id || '');
      setPname(editData.projectId?._id || editData.projectId || '');
      setSiteEngineerName(editData.siteEngineerName || '');
      setQualityInspectorName(editData.qualityInspectorName || '');
      setSafetyIssues(editData.safetyIssue || '');
      setSafetyAudit(editData.safetyAudit || '');
      setIncidentType(editData.incidentType || '');
      setComments(editData.comments || '');
      setAutomatedFollowUps(editData.automatedFollowUps || false);
      setDescription(editData.description || '');
      setDeadLine(formatedDate(editData.deadLine) || '');
      setResult(editData.result || '');
      setArea(editData.area || '');
    }
  }, [edit, editData]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = {
      safetyId: safetyId, // Required for update
      projectId: pname,
      siteEngineerName,
      qualityInspectorName,
      safetyIssue:safetyIssues,
      safetyAudit,
      incidentType,
      comment:comments,
      automatedFollowUps,
      description,
      deadLine,
      result,
      area,
    };

    try {
      if (edit) {
        await updateSafetyInspection(formData);
        handleUpdate();
        onClose();
      } else {
        await addSafetyInspection(formData);
        onClose();
        handleUpdate();
      }
    } catch (error) {
      console.error("Error submitting safety inspection:", error);
    }
  };

  return (
    <Transition.Root show={isOpen} as={React.Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={React.Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={React.Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className={`relative transform overflow-hidden rounded-md ${isDark ? "bg-gray-800 text-white" : "bg-white text-gray-900"} text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl`}
              >
                <div className="px-6 pt-6 pb-4 sm:p-8 sm:pb-6">
                  <form onSubmit={handleSubmit} className="space-y-6">
                    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
                      <div className="col-span-1">
                        <ProjectName pname={pname} handleChange={e => setPname(e.target.value)} />
                      </div>

                      <div className="col-span-1">
                        <label className="block text-sm font-medium mb-3">Incident Type</label>
                        <select
                          name="incidentType"
                          value={incidentType}
                          onChange={e => setIncidentType(e.target.value)}
                          className={`bg-gray-50 border border-gray-300 text-sm rounded-md focus:ring-blue-600 focus:border-blue-600 block w-full p-2 ${isDark ? "bg-gray-700 text-white border-gray-600" : ""}`}
                        >
                          <option value="">Select Incident type</option>
                          <option value="reportable">Reportable</option>
                          <option value="non-reportable">Non-Reportable</option>
                        </select>
                      </div>

                      <div className="col-span-1">
                        <label className="block text-sm font-medium mb-3">Site Engineer Name</label>
                        <input
                          name="siteEngineerName"
                          placeholder="Enter site engineer name"
                          value={siteEngineerName}
                          onChange={e => setSiteEngineerName(e.target.value)}
                          className={`bg-gray-50 border border-gray-300 text-sm rounded-md focus:ring-blue-600 focus:border-blue-600 block w-full p-2 ${isDark ? "bg-gray-700 text-white border-gray-600" : ""}`}
                        />
                      </div>

                      <div className="col-span-1">
                        <label className="block text-sm font-medium mb-2">Quality Inspector Name</label>
                        <input
                          name="qualityInspectorName"
                          placeholder="Enter quality inspector name"
                          value={qualityInspectorName}
                          onChange={e => setQualityInspectorName(e.target.value)}
                          className={`bg-gray-50 border border-gray-300 text-sm rounded-md focus:ring-blue-600 focus:border-blue-600 block w-full p-2 ${isDark ? "bg-gray-700 text-white border-gray-600" : ""}`}
                        />
                      </div>

                      <div className="col-span-1">
                        <label className="block text-sm font-medium mb-2">Safety Issues</label>
                        <input
                          name="safetyIssues"
                          placeholder="Describe safety issues"
                          value={safetyIssues}
                          onChange={e => setSafetyIssues(e.target.value)}
                          className={`bg-gray-50 border border-gray-300 text-sm rounded-md focus:ring-blue-600 focus:border-blue-600 block w-full p-2 ${isDark ? "bg-gray-700 text-white border-gray-600" : ""}`}
                        />
                      </div>

                      <div className="col-span-1">
                        <label className="block text-sm font-medium mb-2">Safety Audit</label>
                        <input
                          name="safetyAudit"
                          placeholder="Enter audit remarks"
                          value={safetyAudit}
                          onChange={e => setSafetyAudit(e.target.value)}
                          className={`bg-gray-50 border border-gray-300 text-sm rounded-md focus:ring-blue-600 focus:border-blue-600 block w-full p-2 ${isDark ? "bg-gray-700 text-white border-gray-600" : ""}`}
                        />
                      </div>

                     
                      <div >
                      <label className="block text-sm font-medium mb-2">Dead Line</label>
                      <input
                        type="date"
                        name="deadLine"
                        value={deadLine}
                        onChange={e => setDeadLine(e.target.value)}
                        className={`bg-gray-50 border border-gray-300 text-sm rounded-md focus:ring-blue-600 focus:border-blue-600 block w-full p-2 ${isDark ? "bg-gray-700 text-white border-gray-600" : ""}`}
                      />
                    </div>

                    <div >
                      <label className="block text-sm font-medium mb-2">Result</label>
                      <input
                        name="result"
                        placeholder="Enter result"
                        value={result}
                        onChange={e => setResult(e.target.value)}
                        className={`bg-gray-50 border border-gray-300 text-sm rounded-md focus:ring-blue-600 focus:border-blue-600 block w-full p-2 ${isDark ? "bg-gray-700 text-white border-gray-600" : ""}`}
                      />
                    </div>

                    <div >
                      <label className="block text-sm font-medium mb-2">Area</label>
                      <input
                        name="area"
                        placeholder="Area or Loaction"
                        value={area}
                        onChange={e => setArea(e.target.value)}
                        className={`bg-gray-50 border border-gray-300 text-sm rounded-md focus:ring-blue-600 focus:border-blue-600 block w-full p-2 ${isDark ? "bg-gray-700 text-white border-gray-600" : ""}`}
                      />
                    </div>
                    </div>

                    

                    
                    <div className="mt-4">
                      <label className="block text-sm font-medium mb-2">Description</label>
                      <textarea
                        name="description"
                        placeholder="Describe the safety inspection"
                        value={description}
                        onChange={e => setDescription(e.target.value)}
                        className={`bg-gray-50 border border-gray-300 text-sm rounded-md focus:ring-blue-600 focus:border-blue-600 block w-full p-2 ${isDark ? "bg-gray-700 text-white border-gray-600" : ""}`}
                      />
                    </div>
                    <div >
                      <label className="block text-sm font-medium mb-2">Comments</label>
                      <textarea
                        name="comments"
                        placeholder="Any additional comments"
                        value={comments}
                        onChange={e => setComments(e.target.value)}
                        className={`bg-gray-50 border border-gray-300 text-sm rounded-md focus:ring-blue-600 focus:border-blue-600 block w-full p-2 ${isDark ? "bg-gray-700 text-white border-gray-600" : ""}`}
                      />
                    </div>
                    {incidentType === "reportable" && (
                        <div className="col-span-2 flex items-center gap-2">
                          <input
                            type="checkbox"
                            name="automatedFollowUps"
                            checked={automatedFollowUps}
                            onChange={e => setAutomatedFollowUps(e.target.checked)}
                          />
                          <span>Automated Follow-ups & Alerts</span>
                        </div>
                      )}
                    <div className="flex justify-between mt-6">
                      <Button variant="outline" color="gray" onClick={onClose}>
                        Cancel
                      </Button>
                      <Button type="submit" color="blue">
                        Submit
                      </Button>
                    </div>
                  </form>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default SafetyAuditForm;
